import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormGroup } from '@angular/forms';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { MessageorderModel } from 'projects/core/src/lib/models/messageorder.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { MessageorderSettingsComponent } from '../messageorder-settings/messageorder-settings.component';

@Component({
  selector: 'app-messageorder-new',
  templateUrl: './messageorder-new.component.html',
  styleUrls: ['./messageorder-new.component.scss']
})
export class MessageorderNewComponent extends BaseForm implements OnInit {

  @ViewChild('settings') settings: MessageorderSettingsComponent;
  @Input() options: any;

  public form = this.fb.group({
    active: new UntypedFormControl(false),
    title: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl(''),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    if (this.auth.checkRightOrRedirect('admin.messageorder.create')) {
      this.ui.setFormFocus();
    }
  }

  onCancel(): void {
    this.router.navigate(['/messageorders']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = {
        active: this.form.get('active').value,
        title: this.form.get('title').value,
        description: this.form.get('description').value,
      };
      this.api.saveModel('messageorders', null, {...payload, ...this.settings.getPayload()}).subscribe({
        next: (result: any) => {
          const messageorder = new MessageorderModel().deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: messageorder.title }), this.transloco.translate('common.saved'));
          this.router.navigate(['/messageorders', messageorder.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
